/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
    BedToJSONTyped,
} from './Bed';
import type { ScreenerBedUnit } from './ScreenerBedUnit';
import {
    ScreenerBedUnitFromJSON,
    ScreenerBedUnitFromJSONTyped,
    ScreenerBedUnitToJSON,
    ScreenerBedUnitToJSONTyped,
} from './ScreenerBedUnit';

/**
 * 
 * @export
 * @interface ScreenerBedRoom
 */
export interface ScreenerBedRoom {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    bed_unit?: ScreenerBedUnit;
    /**
     * 
     */
    beds?: Array<Bed>;
}

/**
 * Check if a given object implements the ScreenerBedRoom interface.
 */
export function instanceOfScreenerBedRoom(value: object): value is ScreenerBedRoom {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ScreenerBedRoomFromJSON(json: any): ScreenerBedRoom {
    return ScreenerBedRoomFromJSONTyped(json, false);
}

export function ScreenerBedRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerBedRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'],
        'name': json['name'],
        'bed_unit': json['bed_unit'] == null ? undefined : ScreenerBedUnitFromJSON(json['bed_unit']),
        'beds': json['beds'] == null ? undefined : ((json['beds'] as Array<any>).map(BedFromJSON)),
    };
}

export function ScreenerBedRoomToJSON(json: any): ScreenerBedRoom {
    return ScreenerBedRoomToJSONTyped(json, false);
}

export function ScreenerBedRoomToJSONTyped(value?: ScreenerBedRoom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'name': value['name'],
        'bed_unit': ScreenerBedUnitToJSON(value['bed_unit']),
        'beds': value['beds'] == null ? undefined : ((value['beds'] as Array<any>).map(BedToJSON)),
    };
}

